import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import ar from '@/i18n/locales/ar.json';
import en from '@/i18n/locales/en.json';
import { languageStorage } from '@/lib/storage';

export const SUPPORTED_LANGUAGES = ['ar', 'en'] as const;
export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];

export const RTL_LANGUAGES: SupportedLanguage[] = ['ar'];

export const DEFAULT_LANGUAGE: SupportedLanguage = 'ar';

export function directionFor(lang: string): 'rtl' | 'ltr' {
  return RTL_LANGUAGES.includes(lang as SupportedLanguage) ? 'rtl' : 'ltr';
}

/** Applies `dir`/`lang` on <html> — called on boot and whenever the language changes. */
export function applyDocumentDirection(lang: string): void {
  document.documentElement.lang = lang;
  document.documentElement.dir = directionFor(lang);
}

const initialLanguage = languageStorage.get() ?? DEFAULT_LANGUAGE;

void i18n.use(initReactI18next).init({
  resources: {
    ar: { translation: ar },
    en: { translation: en },
  },
  lng: initialLanguage,
  fallbackLng: DEFAULT_LANGUAGE,
  interpolation: { escapeValue: false },
  returnEmptyString: false,
});

applyDocumentDirection(initialLanguage);

i18n.on('languageChanged', (lang) => {
  languageStorage.set(lang);
  applyDocumentDirection(lang);
});

export default i18n;
